/*
 *  -----------------------------------------------------------------------
 *    <copyright file="grid-sub-header/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import { GridSubHeaderProps } from '@components/core/grid-header/grid-sub-header/grid-sub-header.interface';
import './styles.scss';

const GridSubHeader = ({ data }: GridSubHeaderProps) => (
    <div className="sub-header">
        {data.map((item) => (
            <div key={item.label} className="sub-header__item">
                <span className="sub-header__label">{item.label}</span>
                <span>{item.text}</span>
            </div>
        ))}
    </div>
);

export default GridSubHeader;
